
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Buscar/deriveSearchTitle",
      function () {
        return require("private-next-pages/Buscar/deriveSearchTitle.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Buscar/deriveSearchTitle"])
      });
    }
  